module.exports = __webpack_public_path__ + "static/img/tery_icon01.54cfc40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc/tery_icon01.png
// module id = YTMo
// module chunks = 1